import axios from 'axios'

export default  {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    update({commit}, childForm) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/raw-item-children/${childForm.id}`, childForm)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    delete({commit}, rawItemId) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/supply-chains/raw-item-children/${rawItemId}`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },

    restore({commit}, rawItemId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/supply-chains/raw-item-children/${rawItemId}/restore`)
          .then(res => {
            resolve(res)
          })
          .catch(error => {
            reject(error)
          })
      })
    },
  },
}
